var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockUnclocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-unlocked-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.16663 11.6667V9.33333C8.16663 6.11167 10.7783 3.5 14 3.5C16.392 3.5 18.4478 4.93978 19.3479 7M14 16.9167V19.25M10.2666 24.5H17.7333C19.6935 24.5 20.6736 24.5 21.4223 24.1185C22.0808 23.783 22.6163 23.2475 22.9518 22.589C23.3333 21.8403 23.3333 20.8602 23.3333 18.9V17.2667C23.3333 15.3065 23.3333 14.3264 22.9518 13.5777C22.6163 12.9191 22.0808 12.3837 21.4223 12.0481C20.6736 11.6667 19.6935 11.6667 17.7333 11.6667H10.2666C8.30644 11.6667 7.32635 11.6667 6.57766 12.0481C5.91909 12.3837 5.38366 12.9191 5.0481 13.5777C4.66663 14.3264 4.66663 15.3065 4.66663 17.2667V18.9C4.66663 20.8602 4.66663 21.8403 5.0481 22.589C5.38366 23.2475 5.91909 23.783 6.57766 24.1185C7.32635 24.5 8.30644 24.5 10.2666 24.5Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnclocked);
export default __webpack_public_path__ + "static/media/lock-unclocked.941c3d639b6066e3f1ccaa846b960ea1.svg";
export { ForwardRef as ReactComponent };